import { useContext } from 'react';
import { DrawerContext, } from '../contexts/drawer-context';
/**
 * useDrawer hook
 *
 * @example
 *     export { useDrawer } from 'hooks/use-drawer;
 *
 *     const BasicDrawerContent = ({title}: string) => <p>This is a basic drawer's content. {title}</p>;
 *
 *     const TestComponent = () => {
 *        const { hideDrawer, openDrawer } = useDrawer();
 *
 *        // Update stencil drawer props
 *        const drawerProps = { position: 'left' };
 *
 *        const openBasicDrawer = () => {
 *          openDrawer(BasicDrawerContent, { title: 'Drawer Title' }, drawerProps);
 *        }
 *
 *        return (
 *          <div>
 *            <button onClick={openBasicDrawer}>Open drawer</button>
 *            <button onClick={hideDrawer}>Close drawer</button>
 *          </div>
 *        )
 *  }
 *
 */
export var useDrawer = function () {
    var context = useContext(DrawerContext);
    if (!context) {
        throw new Error('useDrawer must be used within a DrawerProvider');
    }
    return context;
};
